import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { Avatar } from '@components/basics/Images/Avatar';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { ShelfCreatorFragmentDoc } from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ShelfCreator on User {
    id
    username
    publicAddress
    webappUri
    avatar {
      id
      url
    }
  }
`);

const AVATAR_SIZE = 16;

export const ShelfCreator = ({
  data,
  showAvatar = true,
  className,
}: {
  data: FragmentType<ShelfCreatorFragmentDoc>;
  showAvatar?: boolean;
  className?: string;
}) => {
  const {
    username,
    publicAddress: walletAddress,
    avatar,
    webappUri,
  } = getFragment(ShelfCreatorFragmentDoc, data);

  return (
    <AccessibleLink className={className} pathnameUri={webappUriPath(webappUri)}>
      <div className="mb-1 flex items-center md:mb-0">
        {showAvatar && (
          <>
            <div className="h-4 w-4">
              <Avatar
                src={avatar?.url}
                username={username}
                walletAddress={walletAddress}
                disableLink
                borderRadius="50%"
                size={AVATAR_SIZE}
                webappUri={webappUri}
              />
            </div>
            {SPACE}
          </>
        )}
        {username}
      </div>
    </AccessibleLink>
  );
};
